import React from 'react';
import { CredentialForm } from '@cotera/client/app/components/tools';
import { useTenantedClient } from '@cotera/client/app/stores/org';
import type { CredentialStrategyViewProps } from './credential-strategy-view-props';

/**
 * API key / manual field strategies (`t: 'custom'`) and odd fallbacks.
 * Default handler when no named override matches.
 */
export const UserProvidedStrategyView: React.FC<
  CredentialStrategyViewProps
> = ({ toolKey, provider, strategy, docsUrl, onSuccess }) => {
  const client = useTenantedClient();

  const handleSubmit = async (credentials: Record<string, string>) => {
    const result = await client.toolsV2.createProviderAccount({
      toolKey,
      strategyName: strategy.strategy.name,
      credentials,
    });

    if (result.isErr()) {
      const errorObj = result.error.err;
      throw new Error(
        'message' in errorObj && errorObj.message
          ? errorObj.message
          : 'Failed to save credentials'
      );
    }

    onSuccess();
  };

  return (
    <CredentialForm
      provider={provider}
      strategyName={strategy.strategy.name}
      fields={strategy.credentialFields}
      docsUrl={docsUrl}
      onSubmit={handleSubmit}
    />
  );
};
